import http from "@/services/http";

export const maps = () => {
  // Envia um link do Google Maps (curto ou longo) e recebe { latitude, longitude }.
  // Precisa passar pelo backend: links curtos (maps.app.goo.gl) só revelam a
  // URL final depois de seguir o redirecionamento, e o Google não libera CORS.
  async function resolveLink(url) {
    const { data } = await http.post('/maps/resolve-link', { url });
    return data;
  }

  return { resolveLink };
}
